import { IOTPItem } from 'entities/sendOTP/types';
import { groupBy } from 'lodash';

export const useDefaultSendOTPTableValues = (data: IOTPItem[]) => {
  if (!data.length) {
    return [];
  }

  const groupedData = groupBy(data, 'country_id');

  return Object.keys(groupedData).map((countryId) => ({
    countryId,
    data: groupedData[countryId].map(({ ...restItem }) => restItem),
  }));
};
